/**
 * The mailbox page's sections, as URL segments (context STORY-0267): `/mailboxes/$mailboxId/$section`.
 * Kept out of `mailbox.tsx` for the same reason as `domain-sections.ts`: the router checks them
 * before the page's chunk is fetched. Add, never rename: links point at these.
 */
export const MAILBOX_SECTIONS = [
  'account',
  'forwarding',
  'filters',
  'autoresponder',
  'security',
  'limits',
] as const;
export type MailboxSection = (typeof MAILBOX_SECTIONS)[number];
export const isMailboxSection = (s: string): s is MailboxSection =>
  (MAILBOX_SECTIONS as readonly string[]).includes(s);
